import React, {useState} from 'react'
import {Typography} from '@mui/material'
import AppDialog from 'src/components-new/feedback/AppDialog'
import Button from 'src/components-new/primitives/Button'
import apiClient from 'src/services/apiClient'
import {STATUS} from 'src/constants/constants'

interface ContactMeDialogNewProps {
  open: boolean
  onClose: () => void
  onSuccess: () => void
  onError: () => void
}

export default function ContactMeDialogNew({open, onClose, onSuccess, onError}: ContactMeDialogNewProps): JSX.Element {
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    setLoading(true)
    await apiClient.postContactRequest({}, (status: string) => {
      if (status === STATUS.FULFILLED) {
        onSuccess()
        onClose()
      }
      if (status === STATUS.REJECTED) {
        onError()
        onClose()
      }
    })
    setLoading(false)
  }

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Richiesta di contatto"
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>Annulla</Button>
          <Button variant="primary" onClick={handleConfirm} loading={loading}>Ok</Button>
        </>
      }
    >
      <Typography sx={{pt: 1}}>
        Confermi la richiesta di contatto? Verrai contattato entro e non oltre 1 giorno lavorativo.
      </Typography>
    </AppDialog>
  )
}
